const milestones = [
  {
    node: "01",
    version: "v1",
    status: "Now · Alpha",
    title: "Forge Island",
    copy: "The beach is open. The forge is hungry. Ten alpha transmissions are turning one strange shore into the first complete island.",
    state: "present",
    substeps: [
      {
        version: "v0.1",
        title: "The beach wakes",
        copy: "A walkable shore, a Hoard, the Forge, the Arena, and several extremely confident creatures arrive at once.",
      },
      {
        version: "v0.2",
        title: "The island gets weird",
        copy: "The coast expands. An old fisherman, a burrowing token creature, and suspicious cables start asking better questions.",
      },
      {
        version: "v0.4",
        title: "The Exchange docks",
        copy: "A second shore opens for buying, selling, matching offers, and finding out what somebody else thinks your card is worth.",
      },
      {
        version: "v0.6",
        title: "The island talks back",
        copy: "The tour begins. Fishing pays out cards and points. Packs, invitations, and cross-device progress stop pretending to be local rumors.",
      },
      {
        version: "v0.9",
        title: "The horizon widens",
        copy: "All twelve explorers learn to move, iPad gets the full island, and the Hoard becomes much harder to misplace.",
      },
      {
        version: "v0.10",
        title: "Founder’s Terminal",
        copy: "A second islet opens. The board tracks Hoard Value and the Founder race, trains pass permanent monuments, and the café remains fashionably delayed.",
      },
    ],
  },
  {
    node: "02",
    version: "v2",
    status: "Next signal",
    title: "Broken Forge",
    copy: "Something beneath the furnace has been waiting for the machinery to fail.",
    state: "near",
  },
  {
    node: "03",
    version: "v3",
    status: "Transmission found",
    title: "Data Center — Reanimation",
    copy: "The cable reaches its source. What was consumed does not necessarily stay gone.",
    state: "distant",
  },
  {
    node: "04",
    version: "v4",
    status: "Beyond range",
    title: "Beyond the Node — Rebirth",
    copy: "Past the last familiar signal, the world begins again with different rules.",
    state: "distant",
  },
  {
    node: "05+",
    version: "v5+",
    status: "Signal obscured",
    title: "Unknown",
    copy: "The roadmap ends here. The cable does not.",
    state: "unknown",
  },
] as const;

export function RoadmapPage() {
  return (
    <article className="roadmap-page">
      <header className="roadmap-hero">
        <div className="roadmap-hero__art" aria-hidden="true" />
        <div className="roadmap-hero__veil" aria-hidden="true" />
        <div className="roadmap-hero__copy">
          <p className="eyebrow">Recovered from somewhere past the tide</p>
          <h1>The signal goes on.</h1>
          <p>Forge Island is only the first bubble. Here is what we can see through the static—and what is still looking back.</p>
        </div>
        <div className="roadmap-hero__coordinate" aria-hidden="true"><span>NODE 01</span><i /></div>
      </header>

      <section className="roadmap-transmission" aria-labelledby="roadmap-sequence-title">
        <div className="roadmap-transmission__heading">
          <p className="eyebrow">Development roadmap</p>
          <h2 id="roadmap-sequence-title">Five signals. One cable.</h2>
          <p>Titles and order are real. Everything else is deliberately under the tarp.</p>
        </div>

        <ol className="roadmap-sequence">
          {milestones.map((milestone) => (
            <li className={`roadmap-milestone roadmap-milestone--${milestone.state}`} key={milestone.version}>
              <span className="roadmap-milestone__node" aria-hidden="true">{milestone.node}</span>
              <div className="roadmap-milestone__card">
                <div className="roadmap-milestone__meta">
                  <strong>{milestone.version}</strong>
                  <span>{milestone.status}</span>
                </div>
                <h3>{milestone.title}</h3>
                <p>{milestone.copy}</p>
                {"substeps" in milestone && milestone.substeps && (
                  <ol className="roadmap-substeps" aria-label="Forge Island alpha milestones">
                    {milestone.substeps.map((substep) => (
                      <li key={substep.version}>
                        <span>{substep.version}</span>
                        <div><strong>{substep.title}</strong><p>{substep.copy}</p></div>
                      </li>
                    ))}
                  </ol>
                )}
              </div>
            </li>
          ))}
        </ol>

        <p className="roadmap-disclaimer">Sequence and names are planned direction, not a promise of dates. The machine remains temperamental.</p>
      </section>
    </article>
  );
}
